<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Section, Breadcrumb } from '@storefront/types';

  interface ArticleHeader {
    title: string | null,
    descriptionShort: string | null,
  }

  defineProps({
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
    sections: { type: Array as PropType<Section[]>, required: true },
    article: { type: Object as PropType<ArticleHeader>, required: true },
  });
</script>
<template>
  <main id="main" class="container">
    <SfBreadcrumbs :breadcrumbs />
    <header v-if="article.descriptionShort || article.title" class="article__header">
      <SfHeading v-if="article.title" type="h1">
        {{ article.title }}
      </SfHeading>
      <p v-if="article.descriptionShort">
        {{ article.descriptionShort }}
      </p>
    </header>
    <SectionRenderer :sections />
  </main>

  <RouterView />
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .article {
    &__header {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 0 0 1rem;
    }

    @include media.query(lg) {
      &__header {
        padding: 0 0.625rem 1rem;
      }
    }
  }
</style>